export default __webpack_public_path__ + "static/dont-link-dbced605ce356f90622d38d22d0f6850.png";